import React, { useEffect, useState } from 'react'
import ServicesCard from '../ServicesCard/ServicesCard'
import { API_BASE_URL } from '../../utils/apiConfig'
import AnimateOnScroll from '../../components/ScrollAnimations/AnimateOnScroll'

const ServicesComponent = () => {
  const [services, setServices] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/services/`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch project details');
        return res.json();
      })
      .then(data => {
        console.log('Fetched Services:', data);
        setServices(data);
      })
      .catch(err => {
        setError(err.message)
      });
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!services) return <p className='loading-component'>Loading Services...</p>;


  return (
    <div className='container services'>
<AnimateOnScroll animationClass="slide-in-right" delay={0.5}>
      <div className="ServiceCards">
        {services.map((service, index) => (
          <ServicesCard key={index} servIcon={service.icon} heading={service.title} content={service.short_desc} />
        ))}
      </div>
</AnimateOnScroll>

    </div>
  )
}

export default ServicesComponent